const fontIcons = {
    'check': '\uf00c',
    'arrows': '\uf047',
    'trash': '\uf1f8',
    'rotate': '\uf01e',
    'expand': '\uf065',
    'instruction': '\uf040'
};

export default fontIcons;



// WEBPACK FOOTER //
// ./src/common/fontIcons.js